export const REQUESTS_PATH = "/requests";
